<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<app-form-title [editMode]="product !== undefined" model="Product"></app-form-title>

	<app-text-field [fg]="form" formGroupOrControlName="name" label="Name"></app-text-field>

	<app-engine-dropdown-field
		[fg]="form"
		formGroupOrControlName="engine_name"
		label="Engine"
	></app-engine-dropdown-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="button" (click)="clear()">Clear</button>
	</div>
</form>
